import React, { Component, Fragment } from 'react';

import HowItWorks from '../components/pages/HowItWorks';
import OurVets from '../components/pages/OurVets';

import { TESTIMONIALS, VIDEOS, PAGES } from '../constants/constants';
import Dialog from '@material-ui/core/Dialog';
import { Link } from 'react-router-dom';

import { gaPageview } from '../utils/dev';

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      video: ''
    };

    this.changeModalVideo = this.changeModalVideo.bind(this);
    this.clearVideo = this.clearVideo.bind(this);
  }

  changeModalVideo(video) {
    this.setState({ video: video.video });
  }

  clearVideo() {
    this.setState({ video: '' });
  }
  componentDidMount() {
    const thisPage = PAGES['home'];
    document.title = thisPage.title;

    window.scroll({ top: 0, left: 0, behavior: 'smooth' });

    gaPageview(this.props.location);
  }

  render() {
    const testimonialsView = TESTIMONIALS.map((quote, quoteIndex) => {
      const saying = quote.text.map((text, index) => {
        return (
          <p
            key={`quote-text-${index}`}
            className={index === 0 ? 'main-quote' : ''}
          >
            {text}
          </p>
        );
      });

      const clearDiv =
        (quoteIndex + 1) % 3 === 0 ? (
          <div className='clear' key={`cleardiv-${quoteIndex}`} />
        ) : (
          ''
        );
      return (
        <Fragment key={`testimonial-${quoteIndex}`}>
          <div className='col-md-4'>
            <div className='single-testimonial'>
              <div className='star-rating'>
                <i className='glyphicon glyphicon-star' />
                <i className='glyphicon glyphicon-star' />
                <i className='glyphicon glyphicon-star' />
                <i className='glyphicon glyphicon-star' />
                <i className='glyphicon glyphicon-star' />
              </div>
              <div className='quote'>
                {saying}
                <p className='quoteBy'>-{quote.from}</p>
              </div>
            </div>
          </div>
          {clearDiv}
        </Fragment>
      );
    });

    const mapVideos = VIDEOS.map((video, index) => {
      return (
        <div className='col-sm-4' key={`video-${index}`}>
          <div
            className='video-content'
            style={{ cursor: 'pointer', textAlign: 'center', marginBottom: 20 }}
            onClick={() => {
              this.changeModalVideo(video);
            }}
          >
            <img
              src={video.thumbnail}
              alt='video-youtube'
              className='video-thumbnail'
            />
            <img
              className='yt-play-btn'
              src='/images/yt-play-btn.png'
              alt='youtube-play'
            />
          </div>
        </div>
      );
    });

    return (
      <Fragment>
        <div className='container-fluid hero-container'>
          <div className='row'>
            <div className='home-hero col-md-6 col-md-offset-6 text-center'>
              <div className='hero-content'>
                <h2 className='bold'>Chat with a Vet online</h2>
                <h3>
                  Vetchat connects you with an experienced Australian Vet to
                  help your pet from $39.95
                </h3>
                <Link className='btn btn-vetchat' to='/pricing'>
                  Chat to a Vet now
                </Link>
              </div>
            </div>
          </div>
        </div>
        <HowItWorks />
        <OurVets />
        <div className='container-fluid testimonials'>
          <div className='row'>
            <div
              className='col-sm-12 section-title'
              style={{ paddingBottom: 0 }}
            >
              <div className='container'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <h2>What our pet carers are saying</h2>
                    <p className='text-center'>
                      From our pet carers themselves, read how Vetchat has
                      provided peace of mind, reassurance, understanding of next
                      steps and even saved pets lives.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='container'>
              <div className='row'>{testimonialsView}</div>
            </div>
          </div>
        </div>
        <div className='container vetchat-videos'>
          <div className='row'>
            <div className='col-sm-12 section-title'>
              <h2>Video</h2>
            </div>
            {mapVideos}
            <Dialog
              open={this.state.video !== ''}
              onClose={this.clearVideo}
              maxWidth='md'
              fullWidth={true}
            >
              {this.state.viedo !== '' && (
                <Fragment>
                  <iframe
                    frameBorder='0'
                    allowFullScreen='allowFullScreen'
                    width='100%'
                    height='520px'
                    src={this.state.video}
                    className='video-vetchat-iframe'
                    title='video'
                  />
                </Fragment>
              )}
            </Dialog>
          </div>
        </div>
      </Fragment>
    );
  }
}
